import {useSettings} from '@components/_context';
import {useCallback} from 'react';

interface UseSiteSegments {
  isMultiSegment: () => boolean;
}

export const useSiteSegments = (): UseSiteSegments => {
  const {segments} = useSettings();

  const isMultiSegment = useCallback(() => (segments ? segments.length > 1 : false), [segments]);

  return {
    isMultiSegment,
  };
};
